import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import Loadable from '../../base/components/Template/Loadable/Loadable'
import { proveedorRouteMap } from './ProveedorRoutesMap'

const AppProveedores = Loadable(lazy(() => import('./view/Proveedores')))

const proveedorRoutes = [
  {
    path: proveedorRouteMap.gestion.path,
    element: <AppProveedores />,
    auth: authRoles.admin,
  },
  // {
  //   path: proveedorRouteMap.modificar.path,
  // }
]

export default proveedorRoutes
